import { render } from "./UploadDropArea.vue?vue&type=template&id=6481d109&scoped=true"
import script from "./UploadDropArea.vue?vue&type=script&lang=js"
export * from "./UploadDropArea.vue?vue&type=script&lang=js"

import "./UploadDropArea.vue?vue&type=style&index=0&id=6481d109&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6481d109"]])

export default __exports__